import * as z from 'zod/mini'
import { userFields } from '../schemas/user'

const childName = z.string().check(z.trim(), z.minLength(2), z.maxLength(40))

/**
 * A child user a parent manages. The endpoints taking these are commented out in
 * `child-user.controller.ts` as of 2026-09-19; `ChildUserService` still accepts the types.
 */
export const createChildUserBody = z.object({
  firstName: childName,
  lastName: childName,
  email: userFields.email,
  birthDate: userFields.birthDate,
  phone: z.optional(userFields.phone),
  description: z.optional(userFields.description),
  gender: userFields.gender,
})
export type CreateChildUserBody = z.infer<typeof createChildUserBody>

export const editChildUserBody = z.object({
  childUserId: z.uuid(),
  firstName: z.optional(childName),
  lastName: z.optional(childName),
  birthDate: z.optional(userFields.birthDate),
  phone: z.optional(userFields.phone),
  description: z.optional(userFields.description),
  gender: z.optional(userFields.gender),
})
export type EditChildUserBody = z.infer<typeof editChildUserBody>
